import { all, call, put, takeLatest } from 'redux-saga/effects';
import Schemas from '../models';
import { actions } from '../../constants';
import { fetchListener } from './auth';

function* getInstagram() {
  const onSuccess = function*(response) {
    yield put({ type: actions.INSTAGRAM.LOAD_SUCCESS, payload: response });
  };

  const onError = function*(error) {
    yield put({ type: actions.INSTAGRAM.LOAD_FAIL, payload: error });
  };

  yield call(fetchListener, {
    url: 'api/instagram',
    method: 'GET',
    schema: Schemas.INSTAGRAM_ARRAY,
    onSuccess: onSuccess,
    onError: onError,
    noAuth: true
  });
}

export default function* auth() {
  yield all([yield takeLatest(actions.INSTAGRAM.LOAD, getInstagram)]);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/instagram.js